(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kraven-brand-foundation"] && !Shopify.designMode) return;
  try {
    document.documentElement.dataset.kravenTheme = 'premium'

  const kravenReveal = (root = document) => {
    const nodes = [...root.querySelectorAll('[data-kraven-reveal]:not([data-kraven-observed])')]
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    nodes.forEach((node) => {
      node.dataset.kravenObserved = 'true'
      if (reducedMotion || !('IntersectionObserver' in window)) node.classList.add('is-visible')
    })

    if (reducedMotion || !('IntersectionObserver' in window) || nodes.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        })
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    )

    nodes.forEach((node) => observer.observe(node))
  }

  document.documentElement.classList.add('kraven-motion-ready')
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => kravenReveal(), { once: true })
  } else {
    kravenReveal()
  }

  document.addEventListener('shopify:section:load', (event) => kravenReveal(event.target))
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kraven-build-pairing-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kraven-pair-form')) {
    customElements.define(
      'kraven-pair-form',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort()
          this.abortController = new AbortController()
          const signal = this.abortController.signal

          this.variantInput = this.querySelector('[data-pair-variant-id]')
          this.variantChoices = [...this.querySelectorAll('[data-pair-variant]')]
          this.confirmation = this.querySelector('[data-pair-confirmation]')
          this.price = this.querySelector('[data-pair-price]')
          this.image = this.querySelector('.kraven-build-pair-card__media img')
          this.button = this.querySelector('.kraven-build-pair-card__button')

          this.addEventListener(
            'change',
            (event) => {
              if (event.target.matches('[data-pair-variant]')) this.sync(event.target)
            },
            { signal }
          )
          this.confirmation?.addEventListener('change', () => this.sync(), { signal })
          this.sync()
        }

        disconnectedCallback() {
          this.abortController?.abort()
        }

        sync(changedChoice) {
          const selected =
            changedChoice ||
            this.variantChoices.find((choice) => choice.checked) ||
            this.variantChoices.find((choice) => !choice.disabled)
          const available = selected
            ? selected.dataset.available === 'true'
            : this.dataset.defaultAvailable === 'true'
          const confirmed = this.confirmation?.checked === true

          if (selected && this.variantInput) this.variantInput.value = selected.value
          if (selected?.dataset.price && this.price) this.price.textContent = selected.dataset.price

          if (selected?.dataset.image && this.image) {
            this.image.classList.add('is-switching')
            this.image.removeAttribute('srcset')
            this.image.removeAttribute('sizes')
            this.image.setAttribute('src', selected.dataset.image)
            if (selected.dataset.imageAlt) this.image.alt = selected.dataset.imageAlt

            const finishImageSwitch = () => this.image?.classList.remove('is-switching')
            if (typeof this.image.decode === 'function') {
              this.image.decode().then(finishImageSwitch).catch(finishImageSwitch)
            } else {
              this.image.addEventListener('load', finishImageSwitch, { once: true })
            }
          }

          if (!this.button) return

          this.button.disabled = !available || !confirmed
          const label = this.button.querySelector('.kraven-build-pair-card__button-label')
          if (!label) return

          if (!available) {
            label.textContent = this.dataset.soldOutLabel
          } else if (!confirmed) {
            label.textContent = this.dataset.confirmLabel
          } else {
            label.textContent = this.dataset.addLabel
          }
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
